"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { getTrackingConsent, useTrackingConsent } from "@/hooks/useTrackingConsent";
import { buildAttributionTouch } from "@/utils/tracking/attribution";

// The URL and referrer this document was opened with, and whether analytics
// consent already existed then (in which case the proxy recorded the touch).
// Held in memory only; nothing is stored before consent.
const landing = typeof window === "undefined" ? null : {
  url: window.location.href,
  referrer: document.referrer || null,
  hadAnalyticsConsent: getTrackingConsent().analytics
};
let isRecorded = false;

/**
 * Most visitors accept the cookie banner on the page they landed on, after
 * the proxy has already skipped the attribution cookies for lack of consent.
 * When analytics consent arrives during the visit, record the landing page's
 * campaign parameters once, so purchases keep their ad attribution.
 */
export default function AttributionOnConsent() {
  const $ = _c(3);
  const {
    analytics
  } = useTrackingConsent();
  let t0;
  let t1;
  if ($[0] !== analytics) {
    t0 = () => {
      if (!analytics || !landing || landing.hadAnalyticsConsent || isRecorded) {
        return;
      }
      isRecorded = true;
      try {
        if (!buildAttributionTouch(new URL(landing.url), landing.referrer)) {
          return;
        }
      } catch {
        return;
      }
      fetch("/api/attribution", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          landingUrl: landing.url,
          referrer: landing.referrer
        }),
        keepalive: true
      }).catch(_temp);
    };
    t1 = [analytics];
    $[0] = analytics;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
function _temp() {}